import React from 'react';

const Arrow_Down = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="3509 -14.063 8.783 5.063"><path data-name="Path 1479" d="M3516.783-13.063L3513.392-10 3510-13.063" fill="none" stroke="#3a3a3a" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" /></svg>
);

export default Arrow_Down;
